'use strict';

// need to add jquery to backbone
var $ = require('jquery');
require('backbone').$ = $;
require('./utilities/helpers');
require('./utilities/moment');
require('intl-tel-input');
require('intl-tel-input/build/js/utils');

/* jshint ignore:start */
if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
  $('html').addClass('touch');
} else {
  $('html').addClass('no-touch');
}

if (navigator.userAgent.match(/Android/i)) {
  window.scrollTo(0, 1);
}
/* jshint ignore:end */
var Application = require('./applications/app').default;

window.localStorage.removeItem('timezone', {path: '/'});
window.localStorage.removeItem('previous_timezone', {path: '/'});
var app = new Application();
app.start();
